"use client";

import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { cn } from "~/utils/fontsConfig";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
    React.ElementRef<typeof PopoverPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
    // Removed the .Portal here because it won't let us scroll within modals.. honestly, doens't seem to break any other scroll, so..
    <>
        <PopoverPrimitive.Content
            ref={ref}
            align={align}
            sideOffset={sideOffset}
            className={cn(
                "text-popover-foreground z-50 w-72 rounded-md bg-v3-N-500 p-4 outline-none [--tw-shadow-colored:0_4px_6px_-1px_var(--tw-shadow-color),0_2px_4px_-2px_var(--tw-shadow-color)] [--tw-shadow:0_4px_6px_-1px_#000000,2px_2px_4px_-1px_#0000008f] [box-shadow:var(--tw-ring-offset-shadow,0_0_#0808088a),var(--tw-ring-shadow,0_0_#000000),var(--tw-shadow)] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
                className,
            )}
            {...props}
        />
    </>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
